/** Public path for a destination page nested under a category roll-up page. */
export function destinationPagePublicPath(categorySlug: string, destinationSlug: string): string {
  return `/${categorySlug}/${destinationSlug}`;
}

/** Legacy flat path kept for redirects only. */
export function legacyDestinationPagePublicPath(destinationSlug: string): string {
  return `/destinations/${destinationSlug}`;
}
